import * as Icons from '@lucide/svelte';
import type { IconType } from '../../components/icons/icons.types';

/**
 * The icons of the Entities module, in one place: PageService, pages, buttons and boxes take them from here. A `…Create`
 * icon is the one of the "anlegen" button — `PageDefinition.createIcon`, `Icons.Plus` without one.
 */
class EntitiesIconsClass {
    public readonly Entities: IconType = Icons.BookUser;
    public readonly Organization: IconType = Icons.BuildingComplex;
    public readonly OrganizationCreate: IconType = Icons.BuildingComplexPlus;
    public readonly Person: IconType = Icons.Contact;
    public readonly PersonCreate: IconType = Icons.UserRoundPlus;
    public readonly Position: IconType = Icons.BriefcaseBusiness;
    public readonly PositionCreate: IconType = Icons.BriefcasePlus;
}

export const EntitiesIcons = new EntitiesIconsClass();
